<template>
  <el-dialog
    v-if="step === 'xueshi'"
    top="33vh"
    width="440px"
    :show-close="false"
    custom-class="my-el-dialog iJournal_dialog"
    title="请选择登录方式"
    :visible.sync="$_visible"
    :append-to-body="true">
    <div class="login_select">
      <div class="login_select_item" @click="login('xueshi')">
        <p class="text_size_16 text_weight_bold">一键登录（推荐）</p>
        <p class="text_size_12 text_color_secondary">使用学识云账号信息创建iJournal账号</p>
      </div>
      <div class="login_select_item" @click="login('iJournal')">
        <p class="text_size_16 text_weight_bold">关联iJournal账号</p>
        <p class="text_size_12 text_color_secondary">输入iJournal的账号和密码进行验证和关联</p>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-else-if="step === 'iJournal'"
    top="33vh"
    width="440px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="my-el-dialog"
    title="关联iJournal账号"
    :visible.sync="$_visible">
    <div class="ijournal_form">
      <el-form ref="form" :model="formData" size="small" label-position="left" label-width="120px" :rules="rules" :hide-required-asterisk="true">
        <el-form-item label="iJournal账号" prop="mobile">
          <el-input type="input" v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="iJournal密码" prop="password">
          <el-input type="password" v-model="formData.password"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="small" @click="bindAccount(false)">取消</el-button>
      <el-button type="primary" size="small" @click="bindAccount(true)">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from '~/api'
import SHA256 from 'crypto-js/sha256'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      step: 'xueshi', // xueshi, iJournal
      formData: {
        mobile: '',
        password: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[34578]\d{9}$/, message: '请输入11位数字规范的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    $_visible: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.$emit('update:visible', newValue)
      }
    }
  },
  methods: {
    login (type) {
      if (type === 'xueshi') {
        api.iJournalLogin().then(res => {
          if (res.data.code === 0) {
            this.$emit('login', res.data.data.token)
            this.$_visible = false
            this.step = ''
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(err => {
          this.$message.error('网络错误，请重试！')
          console.log(err)
        })
      }
      if (type === 'iJournal') {
        this.step = 'iJournal'
      }
    },
    bindAccount (isConfirmed) {
      if (!isConfirmed) {
        this.step = 'xueshi'
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          api.iJournalBind({
            account: this.formData.mobile,
            password: SHA256(this.formData.password).toString()
          }).then(res => {
            if (res.data.code === 0) {
              this.$emit('login', res.data.data.token)
              this.$_visible = false
              this.step = ''
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            this.$message.error('网络错误，请重试！')
            console.log(err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login_select {
  &_item {
    width: 400px;
    height: 80px;
    border-radius: 4px;
    box-shadow:0px 1px 4px rgba(0,0,0,0.05);
    background-color: $color-white;
    color: $color-black;
    margin-top: 10px;
    padding: 10px 20px;
    &:hover {
      cursor: pointer;
      background-color: $color-primary;
      & > p {
        color: $color-white;
      }
    }
    & > p {
      line-height: 30px;
    }
  }
}
.ijournal_form {
  padding: 0 20px;
}
</style>

<style lang="scss">
.iJournal_dialog {
  background-color: #F6F7F8;
  .el-dialog__header {
    .el-dialog__title {
      line-height: 20px;
    }
  }
  .el-dialog__body {
    padding: 0 20px 40px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/console/ijournal-dialog.vue